import { CoreIcon } from '../core-icon';
import accountSVG from '../../../src/images/icons/account.svg';

export const AccountIcon = props => {
  return <CoreIcon src={accountSVG} {...props} />;
};
